import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCar, FaFileContract, FaClipboardList, FaTools, FaMoneyBillWave, FaFileInvoice, FaSignOutAlt, FaArrowLeft, FaUserCircle, FaCalendarAlt } from 'react-icons/fa';

import Vehiculos from './Vehiculos';
import Alquilar from './Alquilar';
import Cotizar from './Cotizar';
import Mantenimiento from './Mantenimiento';
import EgresosAlquila from './EgresosAlquila';
import Calendario from './Calendario';
import Recepcion from './Recepcion';

export default function DashboardAlquila({ user, logout }) {
    const [view, setView] = useState('menu');
    const navigate = useNavigate();

    // Configuración de Módulos Base
    const todosLosModulos = [
        {
            key: 'vehiculos',
            label: 'VEHICULOS',
            icon: <FaCar />,
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            desc: 'Flota, Estado y Detalles'
        },
        {
            key: 'alquilar',
            label: 'ENTREGAR',
            icon: <FaFileContract />,
            gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            desc: 'Nueva Renta (Check-in)'
        },
        {
            key: 'recepcion',
            label: 'RECEPCIÓN',
            icon: <FaFileInvoice />,
            gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
            desc: 'Recibir Vehículo (Check-out)'
        },
        {
            key: 'cotizar',
            label: 'COTIZACIÓN',
            icon: <FaClipboardList />,
            gradient: 'linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%)',
            desc: 'Presupuestos PDF'
        },
        {
            key: 'calendario',
            label: 'CALENDARIO',
            icon: <FaCalendarAlt />,
            gradient: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
            desc: 'Disponibilidad de Flota'
        },
        {
            key: 'mantenimiento',
            label: 'MANTENIMIENTO',
            icon: <FaTools />,
            gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            desc: 'Taller y Reparaciones'
        },
        {
            key: 'egresos',
            label: 'EGRESOS',
            icon: <FaMoneyBillWave />,
            gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
            desc: 'Gastos operativos'
        },
    ];

    // --- FILTRO DE PERMISOS (ALQUILACAR) ---
    // Si es ADMIN: Ve todo.
    // Si es CAJA: Ve todo MENOS 'egresos'.
    const modulosVisibles = user.rol === 'admin' 
        ? todosLosModulos 
        : todosLosModulos.filter(m => m.key !== 'egresos');

    const renderContent = () => {
        const propsCommon = { user: user, goBack: () => setView('menu') };
        switch (view) {
            case 'vehiculos': return <Vehiculos {...propsCommon} />;
            case 'alquilar': return <Alquilar {...propsCommon} />;
            case 'recepcion': return <Recepcion {...propsCommon} />;
            case 'cotizar': return <Cotizar {...propsCommon} />;
            case 'calendario': return <Calendario {...propsCommon} />;
            case 'mantenimiento': return <Mantenimiento {...propsCommon} />;
            case 'egresos': return <EgresosAlquila {...propsCommon} />;
            default: return null;
        }
    };

    if (view !== 'menu') {
        return <div className="bg-white min-vh-100">{renderContent()}</div>;
    }

    return (
        <div className="min-vh-100 p-0" style={{background: 'linear-gradient(to bottom, #ffecd2 0%, #fcb69f 100%)'}}>
            {/* BARRA SUPERIOR */}
            <nav className="navbar navbar-dark px-4 shadow-lg" style={{
                background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
            }}>
                <span className="navbar-brand fw-bold d-flex align-items-center" style={{fontSize: '1.4rem'}}>
                    <div className="bg-white bg-opacity-25 p-2 rounded-circle me-3">
                        <FaCar style={{fontSize: '1.5rem'}} />
                    </div>
                    <span style={{letterSpacing: '1px'}}>ALQUILACAR | RENT SYSTEM</span>
                </span>
                
                <div className="d-flex gap-3 align-items-center">
                    <span className="text-white fw-bold d-none d-md-block"><FaUserCircle className="me-2"/> {user.nombre}</span>
                    <button 
                        className="btn btn-light btn-sm fw-bold shadow-sm rounded-pill px-3"
                        onClick={() => {
                            if(user.rol === 'admin') navigate('/admin');
                            else logout();
                        }}
                    >
                        {user.rol === 'admin' ? <><FaArrowLeft className="me-2" /> Menú Principal</> : <><FaSignOutAlt className="me-2" /> Salir</>}
                    </button>
                </div>
            </nav>

            <div className="container py-5">
                {/* HEADER */}
                <div className="text-center mb-5">
                    <div className="mb-4 d-inline-block p-4 rounded-circle shadow-lg" style={{
                        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
                    }}>
                        <FaCar style={{fontSize: '3rem', color: 'white'}} />
                    </div>
                    <h1 className="fw-bold mb-3" style={{ color: '#2d3748', fontSize: '2.5rem', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
                        Panel de Control de Renta
                    </h1>
                    <p className="text-muted" style={{fontSize: '1.1rem'}}>
                        Seleccione una operación para gestionar la flota
                    </p>
                </div>

                {/* TARJETAS */}
                <div className="row g-4 justify-content-center">
                    {modulosVisibles.map((mod) => (
                        <div key={mod.key} className="col-md-6 col-lg-4 col-xl-3">
                            <div 
                                className="card h-100 shadow-lg border-0 text-center"
                                onClick={() => setView(mod.key)}
                                style={{
                                    cursor: 'pointer', borderRadius: '20px', overflow: 'hidden',
                                    transform: 'translateY(0)', transition: 'all 0.3s ease', background: 'white'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-10px)';
                                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '';
                                }}
                            >
                                <div style={{ height: '8px', background: mod.gradient }}></div>
                                <div className="card-body py-5 px-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4 shadow" 
                                         style={{ width: '90px', height: '90px', background: mod.gradient }}>
                                        <div style={{fontSize: '2.5rem', color: 'white'}}>{mod.icon}</div>
                                    </div>
                                    <h5 className="fw-bold mb-2" style={{ color: '#2d3748', fontSize: '1.2rem' }}>{mod.label}</h5>
                                    <p className="text-muted small mb-3" style={{fontSize: '0.9rem'}}>{mod.desc}</p>
                                    <div className="btn btn-sm fw-bold mt-2 shadow-sm rounded-pill px-4 text-white" 
                                         style={{ background: mod.gradient, border: 'none' }}>
                                        ACCEDER
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* FOOTER */}
                <div className="text-center mt-5 pt-5">
                    <small className="text-muted">© 2026 ALQUILACAR - Sistema Integrado</small>
                </div>
            </div>
        </div>
    );
}